import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'
import { BarNestedCategoriesChart } from 'gnos-charts'
import { DataTable, DATA_TABLE_CONSTANTS as CONSTANTS } from 'gnos-tables'

import config from '../../../../../../../../../config'
import { createDataTableId, createChartId } from '../../../../../../helpers'

import { LOCALE_PREFIX } from './constants'
import { ENTITY_CONTEXT_MENU_ITEM } from '../../../../../../../components/Workspace/components/EntityContextMenu/constants'

import NoData from '../../../../../../../components/Workspace/components/NoData'

import EntityContextMenu from '../../../../../../../components/Workspace/components/EntityContextMenu'
import Flag from '../../../../../../../../../components/TableCell/components/Flag'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import './style.scss'

const MODULE_KEY = config.modules.portfolio.key

@hocBlock(MODULE_KEY)
@injectIntl
export default class BranchOfBusiness extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        locale: PropTypes.string.isRequired,
        token: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.block !== nextProps.block) return true
        if (!_.isEqual(this.props.data !== nextProps.data)) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.level !== nextProps.level) return true
        if (this.props.locale !== nextProps.locale) return true
        if (this.props.token !== nextProps.token) return true

        return false
    }

    render() {
        const { data, block, id, level, locale, token, intl } = this.props

        const blockData = _.get(data, 'data', null)
        const dataProvider = _.get(blockData, 'chartData', null)

        if (!blockData || !dataProvider) return null
        if (_.isEmpty(dataProvider)) {
            return <NoData text={<FormattedMessage id={`${LOCALE_PREFIX}.noData`} />} />
        }

        return (
            <div className={cx('block-branch-of-business')}>
                <BarNestedCategoriesChart id={createChartId(MODULE_KEY, id, block)} dataProvider={dataProvider} />
                <DataTable
                    id={createDataTableId(MODULE_KEY, id, block)}
                    uriSettings={_.merge({}, config.api.portfolio[block].table, {
                        qs: { groupId: id, level, token, lang: config.languages[locale].requestKey },
                    })}
                    urlSettingsReloadPaths={[{ path: 'qs.level', reset: true }, { path: 'qs.lang' }]}
                    columnsDefinition={[
                        {
                            Header: '',
                            accessor: 'country',
                            Cell: ({ value }) => <Flag country={value} />,
                            width: 32,
                            resizable: false,
                        },
                        {
                            Header: <FormattedMessage id={`${LOCALE_PREFIX}.table.header.name`} />,
                            accessor: 'name',
                            width: 300,
                            showArrow: {
                                direction: CONSTANTS.DATA_TABLE_ARROW.UP,
                                text: <FormattedMessage id={`${LOCALE_PREFIX}.table.header.name.sort`} />,
                            },
                        },
                        {
                            Header: <FormattedMessage id={`${LOCALE_PREFIX}.table.header.branch`} />,
                            accessor: 'longTxt',
                        },
                    ]}
                    hide={level < 30}
                    contextMenu={
                        <EntityContextMenu
                            id={id}
                            items={[
                                ENTITY_CONTEXT_MENU_ITEM.ADD_FAVOURITE,
                                ENTITY_CONTEXT_MENU_ITEM.REMOVE_FAVOURITE,
                                ENTITY_CONTEXT_MENU_ITEM.REPORT,
                                ENTITY_CONTEXT_MENU_ITEM.LINKAGES,
                                ENTITY_CONTEXT_MENU_ITEM.DISTRAINTS,
                            ]}
                        />
                    }
                    texts={{
                        previousText: intl.formatMessage({ id: 'global.previous' }),
                        nextText: intl.formatMessage({ id: 'global.next' }),
                        loadingText: intl.formatMessage({ id: 'global.loading' }),
                        noDataText: intl.formatMessage({ id: 'global.noData' }),
                        pageText: intl.formatMessage({ id: 'global.page' }),
                        ofText: intl.formatMessage({ id: 'global.of' }),
                        rowsText: intl.formatMessage({ id: 'global.rows' }),
                    }}
                    itemIdentifier={'entId'}
                    showPageSizeOptions
                />
            </div>
        )
    }
}
